'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var pubsub = require('../events/pubsub.js');
var index = require('../events/index.js');
var index$1 = require('../storage/index.js');
var users = require('../methods/users.js');
require('../methods/index.js');
var id = require('../util/id.js');
var magic = require('../magic.js');

class Session {
  constructor() {
    this.onChange = index.events.sessionChange.bind(index.events);
    this.id = null;
    this.ns = "sid";
    this.userNs = "user";
    this.user = null;
    this.sessionCheckInterval = null;
    this.id = index$1.storage.getItem(this.ns) || id.generateId();
    pubsub.pubsub.subscribe(pubsub.Topic.SessionExpired, () => this.destroy());
    pubsub.pubsub.subscribe(pubsub.Topic.SessionKickedOut, () => this.destroy());
    pubsub.pubsub.subscribe(pubsub.Topic.SessionLimitationTimeReached, () => this.destroy());
    pubsub.pubsub.subscribe(pubsub.Topic.SessionSelfExclusion, () => this.destroy());
    pubsub.pubsub.subscribe(pubsub.Topic.SessionLoggedOut, () => this.destroy());
    pubsub.pubsub.subscribe(pubsub.Topic.SessionGeoLocation, () => this.destroy());
    index.events.userUpdated(this.handleUserUpdate.bind(this));
    const currUser = index$1.storage.getItem(this.userNs);
    if (currUser) {
      this.user = JSON.parse(currUser);
    }
  }
  getId() {
    return this.id;
  }
  getUser() {
    return this.user;
  }
  create(user) {
    this.id = user.sessionId;
    this.user = user;
    index$1.storage.setItem(this.ns, user.sessionId);
    index$1.storage.setItem(this.userNs, JSON.stringify(user));
    pubsub.pubsub.publish(pubsub.Topic.SessionCreated);
    this.sessionCheckInterval = setInterval(() => {
      users.users.isLoggedIn().then((userIsLoggedIn) => {
        if (!userIsLoggedIn) {
          this.destroy();
        }
      });
    }, 6e4);
  }
  destroy() {
    if (this.user) {
      magic.magic.methods.users.unsubscribeFromTags(this.user);
    }
    this.user = null;
    index$1.storage.removeItem(this.ns);
    index$1.storage.removeItem(this.userNs);
    pubsub.pubsub.publish(pubsub.Topic.SessionDestroyed);
    if (this.sessionCheckInterval) {
      clearInterval(this.sessionCheckInterval);
      this.sessionCheckInterval = null;
    }
  }
  isCreated() {
    return !!this.user;
  }
  handleUserUpdate(event) {
    if (!this.user) {
      return;
    }
    if (event.roles) {
      const roles = event.roles.map((role) => role.name);
      this.user.roles = roles || [];
    }
    if (event.segment) {
      this.user.segment = event.segment;
    }
  }
}
const session = new Session();

exports.Session = Session;
exports.session = session;
